export const GTM_FOOTBALL_HEADER = ';header;';

export const SPORT_PAGE_TABS = {
    MATCHES: 'matches',
    COMPETITIONS: 'competitions',
    POPULAR_BETS: 'popular-bets',
    VIRTUALS: 'virtuals',
    ODDS_BOOST: 'odds-boost',
};

/**
 * @var {Object} CAROUSEL_ITEMS slug -> item data
 */
export const ALL_CAROUSEL_ITEMS = {
    [SPORT_PAGE_TABS.MATCHES]: {
        i18nKey: 'sports.matches',
    },
    [SPORT_PAGE_TABS.COMPETITIONS]: {
        i18nKey: 'sports.competitions',
    },
    [SPORT_PAGE_TABS.POPULAR_BETS]: {
        i18nKey: 'sports.popular_bets',
    },
    [SPORT_PAGE_TABS.VIRTUALS]: {
        i18nKey: 'virtuals.virtuals',
    },
    [SPORT_PAGE_TABS.ODDS_BOOST]: {
        i18nKey: 'odds_boost.odds_boost',
    },
};

export const GTM_CAROUSEL = 'carousel';
